export enum SubscriptionTier {
  FREE = 'Free',
  STANDARD = 'Standard',
  ADVANCED = 'Advanced',
  DEMO = 'Demo', // When the modal is opened from the "Book a demo" button that's not combined with any tier
}

export type SubscriptionTierInTable = SubscriptionTier.FREE | SubscriptionTier.STANDARD | SubscriptionTier.ADVANCED;

enum Feature {
  'Update your input data' = 'Update your input data',
  'Use your impact data in all external use cases' = 'Use your impact data in all external use cases',
  'All impact metrics, including net impact, UN SDG, EU taxonomy and EU SFDR PAIs, visible for you and all your stakeholders' = 'All impact metrics, including net impact, UN SDG, EU taxonomy and EU SFDR PAIs, visible for you and all your stakeholders',
  'Detailed modelling and custom insights on your impact drivers' = 'Detailed modelling and custom insights on your impact drivers',
  'Share your impact targets and insights' = 'Share your impact targets and insights',
  'Custom data and support for strategic initiatives' = 'Custom data and support for strategic initiatives',
}

export const allFeatures = Object.values(Feature);

type EnabledFeatures = {
  [feature in Feature]?: boolean;
};

type Subscriptions = {
  [tier in SubscriptionTierInTable]: EnabledFeatures;
};

const Free: EnabledFeatures = {
  [Feature['Update your input data']]: true,
};

const standard: EnabledFeatures = {
  ...Free,
  [Feature['Use your impact data in all external use cases']]: true,
  [Feature[
    'All impact metrics, including net impact, UN SDG, EU taxonomy and EU SFDR PAIs, visible for you and all your stakeholders'
  ]]: true,
  [Feature['Detailed modelling and custom insights on your impact drivers']]: true,
  [Feature['Share your impact targets and insights']]: true,
};

const advanced: EnabledFeatures = {
  ...standard,
  [Feature['Custom data and support for strategic initiatives']]: true,
};

export const subscriptionData: Subscriptions = {
  [SubscriptionTier.FREE]: Free,
  [SubscriptionTier.STANDARD]: standard,
  [SubscriptionTier.ADVANCED]: advanced,
};

export const subscriptionHeaders: Array<{
  name: SubscriptionTierInTable;
  description: string;
  buttonText: string;
  // `theme` colors the decorative top stripe on the mobile tier cards only.
  // The tier CTA buttons themselves are rendered black & white (see `buttonOutlined`).
  theme: 'purple' | 'turquoise' | 'yellow';
  // When true the CTA button is a black stroke/outline; when false it is filled black.
  buttonOutlined: boolean;
}> = [
  {
    name: SubscriptionTier.FREE,
    description: 'Update your company information',
    buttonText: 'Sign up for free',
    theme: 'purple',
    buttonOutlined: false,
  },
  {
    name: SubscriptionTier.STANDARD,
    description: 'Starting at 5,000€ / year',
    buttonText: 'Book a demo',
    theme: 'turquoise',
    buttonOutlined: true,
  },
  {
    name: SubscriptionTier.ADVANCED,
    description: 'Starting at 30,000€ / year',
    buttonText: 'Book a demo',
    theme: 'yellow',
    buttonOutlined: true,
  },
];
